import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { useStyleStore } from "@vcl";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";

export default class BackgroundColor extends BaseOption {
  static userInterfaceComponent = {
    label: "Background Color",
    component: inspectorTools.COLOR_PICKER,
    canSetOtherStates: [BaseOption.$states.HOVER],
    props: {
      width: "fill",
      displayAsSelectInput: true,
      colorContext: "Backgrounds",
    },
  };

  static defaultValue = {
    value: "transparent.100",
    source: "palette.background",
  };

  // eslint-disable-next-line no-unused-vars
  static convertConfigValueToCompiledValue(configValue, themeId, themeMode = "inherit", optionValues = {}) {
    if (configValue === "none") {
      return "transparent";
    }
    const styleStore = useStyleStore();
    let palette = styleStore.themePalettes[themeId];
    if (configValue.source && configValue.source.includes("semantic")) {
      palette = styleStore.getSemanticPaletteFromMode(themeId, themeMode);
    }
    return BaseOption.getColorValue(configValue, styleStore.themes[themeId], palette, themeId, themeMode);
  }

  static convertValueToStringForTransactionLog(compiledValue) {
    return compiledValue?.value || "transparent";
  }
}
